'use client';
import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { LMS_EVENTS } from '@/lib/analytics';

// Fires page_viewed on every client-side route change.
// Mount this once inside AnalyticsProvider (see layout.tsx).
export default function RouteAnalytics() {
  const pathname = usePathname();
  const { page } = useAnalytics();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (pathname === lastPath.current) return;
    lastPath.current = pathname;
    page(LMS_EVENTS.PAGE_VIEWED, { path: pathname });
  }, [pathname, page]);

  return null;
}
